import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsComponent } from './reports.component';
import { FlowModule } from '@app/flow';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    FlowModule,
    NgSelectModule,
  ],
  declarations: [ReportsComponent],
  exports: [ReportsComponent]
})
export class ReportsModule { }



// WEBPACK FOOTER //
// ./src/app/reports/reports.module.ts